import { LoadingLazyComponents } from 'ict24h-themes-react'
import { AppRouterItem } from 'ict24h-themes-react/lib/esm/modules/routers/AppRouters'
import { lazy } from 'react'
import { Navigate } from 'react-router-dom'

const ListPageForMe = lazy(
  () => import('./pages/my-tasks/ListPage.ForMe.ProjectTask')
)
const ReportPage = lazy(() => import('./pages/my-tasks/ReportPage.ProjectTask'))

const MyTasksRouters: AppRouterItem[] = [
  {
    path: '/',
    element: <Navigate to="list" />,
  },
  {
    path: '/list',
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ListPageForMe />
      </LoadingLazyComponents>
    ),
  },
  {
    path: `/report`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ReportPage />
      </LoadingLazyComponents>
    ),
  },
]

export default MyTasksRouters
